import DeviceResponse from "../payload/response/DeviceResponse";
import ServiceResponse from "../payload/response/ServiceResponse";
import apiClient from "./apiClient";

export const getDeviceByUserId = async (
  userId: number
): Promise<ServiceResponse<DeviceResponse>> => {
  const response = await apiClient.get<ServiceResponse<DeviceResponse>>(
    `/api/device/devices-by-user-id/${userId}`
  );
  return response.data;
};

export const deleteDevice = async (
  deviceId: number
): Promise<ServiceResponse<any>> => {
  const response = await apiClient.delete<ServiceResponse<any>>(
    `/api/device/delete-device/${deviceId}`
  );
  return response.data;
};
